import { COMMUNITY_DEV_ADMIN_EMAIL } from '../components/Community/communityDevMode';
import type { AdminAccessInfo } from './adminAccessService';

/** Режим демо-показа в workspace (только для presentation-аккаунта) */
export type DemoRoleMode = 'admin' | 'user';

export const WORKSPACE_DEMO_ROLE_KEY = 'dc_workspace_demo_role_v1';

export function isDemoPresentationUser(email: string | null | undefined): boolean {
  return (email ?? '').trim().toLowerCase() === COMMUNITY_DEV_ADMIN_EMAIL;
}

export function readWorkspaceDemoRole(): DemoRoleMode {
  try {
    return localStorage.getItem(WORKSPACE_DEMO_ROLE_KEY) === 'user' ? 'user' : 'admin';
  } catch {
    return 'admin';
  }
}

export function writeWorkspaceDemoRole(mode: DemoRoleMode): void {
  try {
    localStorage.setItem(WORKSPACE_DEMO_ROLE_KEY, mode);
  } catch {
    /* ignore */
  }
}

/** Скрыть админ-панель в UI (роль в БД не меняется) */
export function isWorkspaceAdminHidden(
  access: AdminAccessInfo | null | undefined,
  email: string | null | undefined,
  demoRole: DemoRoleMode,
): boolean {
  if (!access?.hasAdminPanelAccess) return true;
  return isDemoPresentationUser(email) && demoRole === 'user';
}

export function resolveWorkspaceAdminAccess(
  access: AdminAccessInfo | null,
  email: string | null | undefined,
  demoRole: DemoRoleMode,
): AdminAccessInfo | null {
  if (!access?.hasAdminPanelAccess) return null;
  if (isWorkspaceAdminHidden(access, email, demoRole)) return null;
  return access;
}
